import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import type { OrderedListBlock } from '../types';
import { RichSegments } from './RichSegments';
import styles from './ListBlocks.module.css';
interface OrderedListProps {
  block: OrderedListBlock;
  blockId: string;
}
export function OrderedList(t0) {
  const $ = _c(6);
  const {
    block,
    blockId
  } = t0;
  const t1 = block.start;
  let t2;
  if ($[0] !== block.items) {
    t2 = block.items.map(_temp);
    $[0] = block.items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== block.start || $[3] !== blockId || $[4] !== t2) {
    t3 = <ol className={styles.orderedList} data-cms-block-id={blockId} data-cms-field="orderedList" start={t1}>{t2}</ol>;
    $[2] = block.start;
    $[3] = blockId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(segments, idx) {
  return <li key={idx} className={styles.item}><RichSegments segments={segments} /></li>;
}